export const styles = {
  ItemRemovalInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: { xs: '36px 0px 24px 0px', sm: '36px 11px 24px 11px' },
  },
  title: { fontSize: '18px', fontWeight: 500, paddingBottom: { xs: '20px', sm: '47px' } },
  description: { fontSize: '14px', color: 'grey.700', textAlign: 'center' },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f4f4f8',
    borderRadius: '8px',
    justifyContent: 'space-between', // Adjusts spacing between major components
    padding: '12px',
    marginBottom: '24px',
  },
  dealImageStyling: { display: 'flex', justifyContent: 'flex-start', alignItems: 'center', position: 'relative' },
  discountLabel: {
    marginLeft: '16px',
    color: 'grey.700',
  },
  offPriceContainer: { display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center', width: '100%' },
  offPrice: {
    fontWeight: '500',

    color: 'grey.700',
  },
  cancelText: { fontSize: '16px', fontWeight: '500', color: 'primary.dark', marginTop: '19px', cursor: 'pointer' },

  buttonContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'center',
    alignItems: 'center',
    gap: { xs: 0, md: '30px' },
    marginTop: { xs: '0', md: '50px' },
  },
  priceLabel: {
    borderRadius: { xs: '5px', md: '50px' },
    width: '56px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: { xs: '12px', md: '14px' },
    fontWeight: '400',
    lineHeight: '18px',
    textTransform: 'capitalize',
    background: '#66DCA7',
  },
  container: { position: 'absolute', top: '60px', width: '80px', borderRadius: '8px' },
  dealAppliedtag: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '10px',
    backgroundColor: '#E9F3EE',
    color: '#1D8355',
    padding: '8px',
    borderRadius: '50px',
  },
};
